import { logVectorTileLayerStyleCall } from './logVectorTileLayerStyleCall';

export function vectorTileStyleLayersDeepEqual(
	a: unknown,
	b: unknown,
): boolean {
	try {
		return JSON.stringify(a) === JSON.stringify(b);
	} catch {
		return false;
	}
}

type VtlWithStyleLayerApi = {
	getStyleLayer?: (id: string) => unknown;
	setStyleLayer?: (layer: unknown) => void;
	id?: string;
};

/**
 * Invokes `VectorTileLayer#setStyleLayer` only when the payload differs from
 * `getStyleLayer(next.id)` (deep compare via JSON serialization).
 *
 * @returns whether `setStyleLayer` was invoked
 */
export function setVectorTileLayerStyleLayerIfChanged(
	vtl: VtlWithStyleLayerApi,
	next: Record<string, unknown> & { id?: string },
	logDetail?: Record<string, unknown>,
): boolean {
	const id = next.id;
	if (typeof id !== 'string' || !vtl.getStyleLayer || !vtl.setStyleLayer) {
		return false;
	}
	const existing = vtl.getStyleLayer(id);
	if (vectorTileStyleLayersDeepEqual(existing, next)) {
		return false;
	}
	logVectorTileLayerStyleCall('setStyleLayer', vtl, {
		styleLayerId: id,
		...logDetail,
	});
	vtl.setStyleLayer(next);
	return true;
}
